import React from "react"
import Label from "../Label"
import I18n from "i18n"
import { TabBarLabelProps } from "components/types"

export default (props: TabBarLabelProps) => (
  <Label label={I18n.t("title_seller_orders_offer_requests_tab")} {...props} />
)
